import Navigation from './Navigation';
import Footer from './Footer';
import { CookieConsent } from './compliance/CookieConsent';
import { SkipLinks } from './compliance/SkipLinks';
import ExitIntentCapture from './ExitIntentCapture';
import ScrollToTopButton from './ScrollToTopButton';
import StickyBookCTA from './StickyBookCTA';
import ThirdPartyScripts from './ThirdPartyScripts';
import LocaleSync from './LocaleSync';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  return (
    <div className="min-h-screen flex flex-col">
      <LocaleSync />
      <SkipLinks />
      <Navigation />
      <main id="main-content" className="flex-1" tabIndex={-1}>
        {children}
      </main>
      <Footer />
      <ScrollToTopButton />
      <StickyBookCTA />
      <ExitIntentCapture />
      <CookieConsent />
      <ThirdPartyScripts />
    </div>
  );
};

export default Layout;